import React from 'react';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import DialogAriaWrapper from '../DialogAriaWrapper';

interface DeactivatedAccountDialogProps {
  open: boolean;
  onClose: () => void;
}
const DeactivatedAccountDialog: React.FC<DeactivatedAccountDialogProps> = ({ open, onClose }) => {
  return (
    <DialogAriaWrapper
      open={open}
      onClose={(e: any) => {
        e.preventDefault();
        onClose();
      }}
    >
      <DialogTitle>Deactivated Account</DialogTitle>
      <DialogContent>
        <p>Your account has been deactivated. Please contact your association.</p>
      </DialogContent>
      <DialogActions>
        <Button fullWidth variant='contained' onClick={onClose}>
          I Understand
        </Button>
      </DialogActions>
    </DialogAriaWrapper>
  );
};
export default DeactivatedAccountDialog;
